var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path10, _g3, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _rect, _path18, _path19, _g5, _g6, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g7, _path58, _path59, _path60, _g8, _path61, _path62, _g9, _path63, _g10, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g11, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeoplesad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_257",
    "data-name": "Group 257",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210.941,
    height: 213.681,
    viewBox: "0 0 210.941 213.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 210.941,
    height: 213.681,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 5.492,
    height: 11.051,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 18.313,
    height: 5.273,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 4.255,
    height: 4.925,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 4.255,
    height: 4.926,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 6.514,
    height: 46.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 5.304,
    height: 9.297,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 4.391,
    height: 5.083,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_109",
    "data-name": "Rectangle 109",
    width: 16.919,
    height: 12.591,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 43.211,
    height: 66.175,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M50.378,288.755a15.81,15.81,0,0,1-3.274-5.711,33.785,33.785,0,0,1-1.438-6.38c-.3-2.112-.455-4.187-.671-6.169-.064-.5-.1-.993-.152-1.489l-.178-1.486c-.124-.989-.221-1.981-.382-2.964-.532-3.949-1.2-7.879-1.982-11.85q-.583-2.979-1.218-6.015c-.417-2.033-.873-4.077-1.226-6.234a36.033,36.033,0,0,1,7.033,10.8,44.66,44.66,0,0,1,2.155,6.113c.3,1.041.519,2.1.764,3.157.194,1.065.39,2.131.535,3.2s.243,2.153.329,3.233c.056,1.082.118,2.164.105,3.247,0,2.172-.153,4.259-.32,6.3-.33,4.1-.714,7.937-.08,12.236",
    transform: "translate(-15.47 -93.33)",
    fill: "#ffd5ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M88.277,19.968v5.3a15.209,15.209,0,0,0-4.03-1.939,34.05,34.05,0,0,0-11.154-1.675,34.047,34.047,0,0,0-11.154,1.675,15.209,15.209,0,0,0-4.03,1.939v-5.3a38.619,38.619,0,0,1,30.369,0",
    transform: "translate(-22.476 -6.547)",
    fill: "#2c3344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M88.277,15.315v2.847a38.619,38.619,0,0,0-30.369,0V15.315a38.619,38.619,0,0,1,30.369,0",
    transform: "translate(-22.476 -4.741)",
    fill: "#ed4f4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M88.277,7.572v4.54a38.619,38.619,0,0,0-30.369,0V7.572S62.6,3.963,73.093,3.963,88.277,7.572,88.277,7.572",
    transform: "translate(-22.476 -1.538)",
    fill: "#2c3344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M84.594,43.646a19,19,0,0,1-3.409,9.444,10.631,10.631,0,0,1-8.846,4.194A10.624,10.624,0,0,1,63.8,53.465c-3.4-4.036-3.714-9.819-3.714-9.819-2.361-.287-4.944-4.886-3.866-7.534a2.389,2.389,0,0,1,1.107-1.33,2.674,2.674,0,0,1,2.378.328l1.523-8.635-.041-.117a34.031,34.031,0,0,1,11.154-1.676,34.028,34.028,0,0,1,11.154,1.676l-.041.117,1.523,8.635a2.675,2.675,0,0,1,2.379-.328,2.39,2.39,0,0,1,1.107,1.33c1.078,2.648-1.506,7.247-3.866,7.534",
    transform: "translate(-21.722 -9.58)",
    fill: "#ff9a55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M104.959,29.36l-.17,6.485a2.674,2.674,0,0,0-2.378.328l-1.523-8.635.041-.117a15.185,15.185,0,0,1,4.03,1.939",
    transform: "translate(-39.158 -10.643)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(47.213 24.388)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257-2",
    "data-name": "Group 257",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M81.233,39.858s1.547,10.9,1.412,10.908c-3.07.381-5.483.029-5.483-1.406s4.071-9.5,4.071-9.5",
    transform: "translate(-77.162 -39.858)",
    fill: "#21232b"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M86.4,75.58a55.393,55.393,0,0,1-9.344.8q-1.433.008-2.988-.07c-.6-.029-1.207-.065-1.828-.117-1.336-.105-2.724-.269-4.153-.492l.416-4.218a11.442,11.442,0,0,0,17.387-.374Z",
    transform: "translate(-26.426 -27.6)",
    fill: "#ff9a55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M61.938,27.421l.041.117-1.523,8.635a2.675,2.675,0,0,0-2.379-.328l-.169-6.485a15.209,15.209,0,0,1,4.03-1.939",
    transform: "translate(-22.476 -10.643)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(41.659 43.51)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M86.4,75.58a55.393,55.393,0,0,1-9.344.8q-1.433.008-2.988-.07c-.6-.029-1.207-.065-1.828-.117-1.336-.105-2.724-.269-4.153-.492l.416-4.218a11.442,11.442,0,0,0,17.387-.374Z",
    transform: "translate(-68.085 -71.11)",
    fill: "#21232b"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M83.617,63.161a5.116,5.116,0,0,0-6.36,0c-.234.2-.576-.138-.341-.341a5.612,5.612,0,0,1,7.043,0c.245.19-.1.528-.341.341",
    transform: "translate(-29.823 -23.9)",
    fill: "#21232b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M71.989,34.1a10.178,10.178,0,0,0-3.94,1.186c-1.439.783-.156,2.982,1.284,2.2a6.987,6.987,0,0,1,2.656-.839,1.309,1.309,0,0,0,1.273-1.273A1.282,1.282,0,0,0,71.989,34.1",
    transform: "translate(-26.168 -13.232)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(42.612 23.98)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M73.9,41.654a2.15,2.15,0,1,1-2.127-2.463A2.314,2.314,0,0,1,73.9,41.654",
    transform: "translate(-69.643 -39.191)",
    fill: "#21232b"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M73.694,43.2a1.632,1.632,0,1,1-3.139,0,1.632,1.632,0,1,1,3.139,0",
    transform: "translate(-27.385 -15.961)",
    fill: "#21232b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M89.242,33.767a10.178,10.178,0,0,1,3.94,1.186c1.439.783.156,2.982-1.284,2.2a6.987,6.987,0,0,0-2.656-.839,1.309,1.309,0,0,1-1.273-1.273,1.282,1.282,0,0,1,1.273-1.273",
    transform: "translate(-34.144 -13.105)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(54.052 23.778)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M88.34,41.325a2.15,2.15,0,1,0,2.127-2.463,2.313,2.313,0,0,0-2.127,2.463",
    transform: "translate(-88.34 -38.862)",
    fill: "#21232b"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M89.251,43a1.595,1.595,0,1,0,1.569-1.878A1.744,1.744,0,0,0,89.251,43",
    transform: "translate(-34.642 -15.961)",
    fill: "#21232b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M87.337,327.3H63.043c-.908-3.433-4.745-16.14-6.948-23.381-.931-3.064-1.57-5.149-1.57-5.149l-2.056,6.485-7,22.045H21.707l.914-11.037,1.951-23.539a146.336,146.336,0,0,0,22.068,3.012c2.015.128,4.13.222,6.321.269a153.272,153.272,0,0,0,31.055-2.384Z",
    transform: "translate(-8.425 -113.616)",
    fill: "#2c3344"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M81.162,281.006a1.771,1.771,0,1,1-1.689-1.85,1.772,1.772,0,0,1,1.689,1.85",
    transform: "translate(-30.128 -108.35)",
    fill: "#ffa840"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M136.857,91.49l-.814,3.058-.123.463L118.878,89.75l1.072-2.794.041-.105Z",
    transform: "translate(-46.141 -33.71)",
    fill: "#ffb048"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M.264,138.516c-2.158-12.63,9.42-43.347,15.642-48.807l.363,1.353L33.317,85.8,32.2,82.9c3.872-1.066,6.924-1.77,6.924-1.77l.329-3.339c.744.152,1.482.281,2.208.4,1.429.223,2.818.387,4.154.492l1.828.117q1.555.079,2.988.07a55.458,55.458,0,0,0,9.344-.8c1.647-.287,2.572-.545,2.572-.545l1.606,3.551s4.423.814,9.66,2.261L72.737,86.13l17.042,5.261.123-.463a3.648,3.648,0,0,1,.3.463c5.97,10.545,8.63,52.063,8.794,59.28S80.107,164.35,80.107,164.35v44.84q-2.276.492-4.517.9a153.28,153.28,0,0,1-31.055,2.384A152.381,152.381,0,0,1,16.146,209.2c-2.308-.51-3.568-.872-3.568-.872L19.2,121.79s-1.7,25.819-1.7,34.44",
    transform: "translate(0 -30.09)",
    fill: "#ed4f4f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 16.778,
    height: 4.235,
    transform: "translate(57.822 78.484)",
    fill: "#ffb048"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M41.924,86.314l1.119,2.9L25.995,94.474l-.363-1.353-.574-2.168L41.238,86.5Z",
    transform: "translate(-9.726 -33.502)",
    fill: "#ffb048"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M71.882,79.538l-3.1,133.674c-2.191-.047-4.306-.141-6.321-.269L70.03,79.672l.024-.251c.621.053,1.23.088,1.828.117",
    transform: "translate(-24.241 -30.826)",
    fill: "#ffb048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(77.285 87.523)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M129.133,189.781l-2.822-46.737,6.515,24.59-2.073,6.459Z",
    transform: "translate(-126.311 -143.043)",
    fill: "#2c3344"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(12.529 87.523)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M24.169,189.781l2.822-46.737-6.515,24.59,2.073,6.459Z",
    transform: "translate(-20.477 -143.043)",
    fill: "#2c3344"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M136.2,100.944a32.492,32.492,0,0,0-10.178,18.326,31.6,31.6,0,0,0-.5,6.019.293.293,0,0,0,.586,0,31.97,31.97,0,0,1,6.51-19.607,30.844,30.844,0,0,1,4-4.323c.281-.252-.134-.665-.414-.414",
    transform: "translate(-48.718 -39.15)",
    fill: "#21232b"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M32.974,116.363q-1.361,11.148-2.723,22.294-.385,3.159-.772,6.318c-.045.373.541.37.586,0l2.722-22.294q.386-3.159.772-6.318c.046-.373-.54-.37-.586,0",
    transform: "translate(-11.441 -45.057)",
    fill: "#21232b"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M83.853,221.932a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-31.172 -85.421)",
    fill: "#ffa840"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M82.54,250.734a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-30.663 -96.601)",
    fill: "#ffa840"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M88.172,133.177a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-32.849 -50.972)",
    fill: "#ffa840"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M86.86,161.979a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-32.339 -62.151)",
    fill: "#ffa840"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M85.481,192.251a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-31.804 -73.901)",
    fill: "#ffa840"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M88.551,103.537a1.771,1.771,0,1,1-1.689-1.85,1.771,1.771,0,0,1,1.689,1.85",
    transform: "translate(-32.996 -39.468)",
    fill: "#ffa840"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M198.944,59.273a287.013,287.013,0,0,1-3.087,30.867,121.005,121.005,0,0,1-8.588,29.634,111,111,0,0,1-38.907,46.732l1.392,2.013a112.831,112.831,0,0,0,38.639-48.261,121.967,121.967,0,0,0,8.068-30.023,287.114,287.114,0,0,0,2.483-30.962",
    transform: "translate(-57.585 -23.006)",
    fill: "#ffd5ab"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M229.737,39.344a31.76,31.76,0,0,0,3.352-9.735A45.714,45.714,0,0,0,232.2,9.4,31.522,31.522,0,0,0,227.991,0a75.629,75.629,0,0,0-.556,10.061c0,3.257.082,6.461.229,9.663s.349,6.4.636,9.645a77.092,77.092,0,0,0,1.437,9.973",
    transform: "translate(-88.276 0)",
    fill: "#ffd5ab"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M215.394,66.666a15.808,15.808,0,0,0-.78-6.536,33.823,33.823,0,0,0-2.652-5.979c-1.022-1.872-2.133-3.631-3.142-5.351-.245-.436-.511-.858-.767-1.286l-.744-1.3c-.491-.867-1-1.721-1.462-2.607-1.929-3.486-3.735-7.041-5.48-10.693q-1.31-2.739-2.611-5.554c-.877-1.88-1.732-3.792-2.735-5.734a36.029,36.029,0,0,0,.8,12.866,44.65,44.65,0,0,0,1.918,6.191c.379,1.015.838,2,1.27,2.989.48.97.959,1.943,1.482,2.892s1.09,1.873,1.665,2.791c.6.9,1.2,1.806,1.853,2.669,1.294,1.744,2.663,3.326,4.018,4.868,2.711,3.092,5.309,5.944,7.364,9.772",
    transform: "translate(-75.592 -8.395)",
    fill: "#ffd5ab"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M228.435,66.666c2.056-3.828,4.654-6.68,7.364-9.772,1.354-1.542,2.723-3.124,4.017-4.868.657-.863,1.252-1.767,1.853-2.669.575-.918,1.14-1.844,1.665-2.791s1-1.921,1.482-2.892c.433-.994.891-1.974,1.27-2.989a44.648,44.648,0,0,0,1.918-6.191,36.042,36.042,0,0,0,.8-12.866c-1,1.941-1.858,3.854-2.736,5.734s-1.738,3.728-2.611,5.554c-1.745,3.652-3.551,7.207-5.48,10.693-.458.885-.971,1.74-1.462,2.607l-.744,1.3c-.256.428-.521.85-.767,1.286-1.009,1.719-2.12,3.479-3.142,5.351a33.824,33.824,0,0,0-2.652,5.979,15.809,15.809,0,0,0-.78,6.536",
    transform: "translate(-88.632 -8.395)",
    fill: "#ffd5ab"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M211.409,105.127a15.819,15.819,0,0,0,.113-6.581,33.863,33.863,0,0,0-1.818-6.283c-.759-1.993-1.621-3.887-2.389-5.727-.184-.466-.39-.92-.586-1.379l-.56-1.387c-.369-.926-.762-1.842-1.1-2.781-1.439-3.716-2.746-7.482-3.981-11.336q-.927-2.891-1.834-5.857c-.616-1.981-1.2-3.992-1.934-6.051a36.029,36.029,0,0,0-.948,12.856,44.7,44.7,0,0,0,1.062,6.393c.237,1.057.559,2.09.854,3.133.344,1.027.686,2.055,1.077,3.065s.826,2,1.272,2.991c.473.975.94,1.952,1.475,2.9,1.046,1.9,2.188,3.656,3.321,5.367,2.267,3.431,4.455,6.608,5.973,10.679",
    transform: "translate(-76.149 -22.413)",
    fill: "#ffd5ab"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M221.062,108.627c2.555-3.515,5.516-5.988,8.62-8.685,1.55-1.344,3.122-2.726,4.64-4.279.768-.765,1.48-1.58,2.2-2.393.694-.831,1.379-1.672,2.028-2.539s1.253-1.768,1.86-2.664c.564-.926,1.151-1.835,1.664-2.789a44.716,44.716,0,0,0,2.738-5.875,36.032,36.032,0,0,0,2.537-12.639c-1.257,1.788-2.362,3.568-3.487,5.311s-2.227,3.458-3.339,5.149c-2.224,3.381-4.494,6.659-6.877,9.852-.573.815-1.2,1.592-1.8,2.385l-.912,1.186c-.311.389-.632.772-.934,1.17-1.233,1.566-2.572,3.16-3.838,4.876a33.815,33.815,0,0,0-3.437,5.564,15.808,15.808,0,0,0-1.658,6.37",
    transform: "translate(-85.802 -25.913)",
    fill: "#ffd5ab"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M222.862,47.69a8.9,8.9,0,0,0-.174-4.051,18.97,18.97,0,0,0-1.435-3.724c-1.191-2.318-2.369-4.263-3.477-6.352-1.123-2.063-2.214-4.144-3.322-6.28-1.133-2.134-2.206-4.326-3.617-6.618a18.919,18.919,0,0,0-.027,7.858,25.392,25.392,0,0,0,2.667,7.378,26.536,26.536,0,0,0,2.14,3.307,35.747,35.747,0,0,0,2.474,2.879,40.693,40.693,0,0,1,4.769,5.6",
    transform: "translate(-81.668 -8.021)",
    fill: "#ffd5ab"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M230.67,47.785a40.7,40.7,0,0,1,4.837-5.542,35.818,35.818,0,0,0,2.51-2.849,26.561,26.561,0,0,0,2.181-3.28,25.389,25.389,0,0,0,2.758-7.345,18.93,18.93,0,0,0,.07-7.858c-1.439,2.274-2.539,4.453-3.7,6.573-1.134,2.123-2.25,4.189-3.4,6.239-1.133,2.074-2.335,4-3.554,6.308a18.971,18.971,0,0,0-1.481,3.706,8.91,8.91,0,0,0-.223,4.049",
    transform: "translate(-89.476 -8.116)",
    fill: "#ffd5ab"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M202.519,135.326a15.817,15.817,0,0,0,.732-6.541,33.868,33.868,0,0,0-1.218-6.426c-.568-2.055-1.249-4.022-1.839-5.927-.139-.48-.3-.952-.453-1.427l-.428-1.434c-.28-.956-.585-1.905-.829-2.871-1.083-3.835-2.03-7.708-2.9-11.661q-.651-2.964-1.275-6c-.426-2.03-.822-4.087-1.356-6.207a36.034,36.034,0,0,0-2.154,12.71,44.591,44.591,0,0,0,.455,6.465c.137,1.075.36,2.134.555,3.2.246,1.054.49,2.11.783,3.154s.635,2.072.985,3.1c.379,1.015.753,2.032,1.2,3.021.862,1.993,1.834,3.846,2.8,5.656,1.933,3.629,3.813,7,4.941,11.194",
    transform: "translate(-74.057 -33.701)",
    fill: "#ffd5ab"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M209.953,141.221c2.875-3.259,6.055-5.443,9.4-7.836,1.67-1.192,3.364-2.419,5.022-3.823.836-.69,1.622-1.435,2.413-2.176.769-.762,1.53-1.535,2.258-2.337s1.414-1.642,2.1-2.477c.648-.869,1.319-1.719,1.918-2.621a44.648,44.648,0,0,0,3.279-5.591,36.031,36.031,0,0,0,3.715-12.344c-1.42,1.662-2.688,3.329-3.972,4.959s-2.542,3.234-3.808,4.812c-2.532,3.157-5.1,6.206-7.774,9.161-.648.757-1.343,1.472-2.019,2.2l-1.02,1.1c-.347.358-.7.709-1.04,1.077-1.375,1.443-2.857,2.9-4.279,4.493a33.811,33.811,0,0,0-3.945,5.216,15.808,15.808,0,0,0-2.25,6.186",
    transform: "translate(-81.49 -39.596)",
    fill: "#ffd5ab"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M183.144,169.6a15.811,15.811,0,0,0,1.611-6.382,33.819,33.819,0,0,0-.337-6.532c-.285-2.113-.692-4.154-1.019-6.12-.072-.5-.169-.984-.256-1.475l-.229-1.479c-.148-.986-.322-1.967-.433-2.958-.554-3.946-.967-7.911-1.29-11.945-.162-2.017-.315-4.054-.45-6.12s-.261-4.161-.5-6.333a36.011,36.011,0,0,0-3.855,12.3,44.626,44.626,0,0,0-.425,6.467c-.01,1.083.067,2.163.116,3.245.1,1.078.2,2.157.349,3.231s.348,2.139.556,3.2c.239,1.057.471,2.115.776,3.155.584,2.093,1.3,4.059,2.009,5.983,1.424,3.858,2.83,7.45,3.38,11.761",
    transform: "translate(-68.295 -46.675)",
    fill: "#ffd5ab"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M187.7,178.847c3.289-2.84,6.736-4.572,10.374-6.49,1.817-.955,3.661-1.942,5.493-3.108.922-.57,1.8-1.2,2.686-1.829.865-.651,1.724-1.313,2.553-2.01s1.623-1.435,2.419-2.17c.76-.773,1.539-1.524,2.255-2.337a44.608,44.608,0,0,0,4.006-5.094,36.024,36.024,0,0,0,5.353-11.728c-1.632,1.454-3.114,2.935-4.606,4.375s-2.957,2.86-4.426,4.252c-2.936,2.785-5.894,5.458-8.942,8.024-.745.663-1.53,1.276-2.3,1.911l-1.159.947c-.392.308-.791.607-1.176.927-1.558,1.244-3.225,2.49-4.849,3.872a33.851,33.851,0,0,0-4.615,4.634,15.82,15.82,0,0,0-3.067,5.824",
    transform: "translate(-72.855 -55.923)",
    fill: "#ffd5ab"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M248.677,176.346a113.342,113.342,0,0,1-92.733,58.877l.281,3.743a115.218,115.218,0,0,0,92.452-62.621",
    transform: "translate(-60.528 -68.446)",
    fill: "#ffd5ab"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M314.463,125.6c-1.348,3.041-2.378,6.068-3.42,9.078-1.021,3.012-2,6.008-2.96,9.012s-1.9,6.011-2.818,9.057c-.9,3.055-1.81,6.119-2.47,9.381A39.386,39.386,0,0,0,308.337,154a55.7,55.7,0,0,0,3.767-9.032,56.288,56.288,0,0,0,2.16-9.544,39.719,39.719,0,0,0,.2-9.83",
    transform: "translate(-117.526 -48.748)",
    fill: "#ffd5ab"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M288.223,135.225a14.594,14.594,0,0,0-3.442,4.311,21.363,21.363,0,0,0-1.96,5.246,32.467,32.467,0,0,0-.491,11.031,72.133,72.133,0,0,0,2.14,10.44c.923,3.382,1.875,6.675,2.879,10.175a33.073,33.073,0,0,0,.762-10.771c-.236-3.558-.732-7.009-1.122-10.379a67.984,67.984,0,0,1-.527-9.989,34.044,34.044,0,0,1,1.76-10.064",
    transform: "translate(-109.485 -52.486)",
    fill: "#ffd5ab"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M323.684,162.692a34.054,34.054,0,0,1-7.222,7.227,67.99,67.99,0,0,1-8.477,5.312c-2.981,1.618-6.09,3.2-9.136,5.05a33.092,33.092,0,0,0-8.375,6.817c3.44-1.191,6.683-2.3,9.98-3.494a72.082,72.082,0,0,0,9.773-4.252,32.456,32.456,0,0,0,8.744-6.743,21.375,21.375,0,0,0,3.166-4.62,14.6,14.6,0,0,0,1.548-5.3",
    transform: "translate(-112.744 -63.147)",
    fill: "#ffd5ab"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M271.109,159.155a14.6,14.6,0,0,0-3.749,4.047,21.361,21.361,0,0,0-2.339,5.089,32.478,32.478,0,0,0-1.3,10.965,72.159,72.159,0,0,0,1.369,10.569c.672,3.441,1.381,6.8,2.126,10.359a33.1,33.1,0,0,0,1.549-10.687c.026-3.565-.216-7.044-.358-10.433a68.053,68.053,0,0,1,.206-10,34.05,34.05,0,0,1,2.493-9.908",
    transform: "translate(-102.348 -61.774)",
    fill: "#ffd5ab"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M304.147,190.4a34.071,34.071,0,0,1-7.732,6.678,68.062,68.062,0,0,1-8.843,4.676c-3.092,1.4-6.308,2.742-9.482,4.367a33.08,33.08,0,0,0-8.852,6.185c3.518-.936,6.834-1.809,10.21-2.754a72.091,72.091,0,0,0,10.058-3.524,32.467,32.467,0,0,0,9.214-6.085,21.353,21.353,0,0,0,3.5-4.375,14.609,14.609,0,0,0,1.932-5.168",
    transform: "translate(-104.501 -73.903)",
    fill: "#ffd5ab"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M257.555,183.795a14.6,14.6,0,0,0-4.7,2.889,21.4,21.4,0,0,0-3.622,4.272,32.472,32.472,0,0,0-4.2,10.211,72.111,72.111,0,0,0-1.526,10.547c-.278,3.495-.5,6.916-.74,10.549a33.064,33.064,0,0,0,4.368-9.875c.985-3.426,1.688-6.842,2.464-10.144a67.984,67.984,0,0,1,2.889-9.577,34.059,34.059,0,0,1,5.068-8.871",
    transform: "translate(-94.226 -71.338)",
    fill: "#ffd5ab"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M282.074,227.477a34.052,34.052,0,0,1-9.244,4.351,68.047,68.047,0,0,1-9.776,2.123c-3.353.512-6.813.943-10.307,1.654a33.08,33.08,0,0,0-10.189,3.574c3.64.047,7.068.1,10.574.1a72.079,72.079,0,0,0,10.635-.687,32.475,32.475,0,0,0,10.512-3.381,21.369,21.369,0,0,0,4.544-3.273,14.6,14.6,0,0,0,3.251-4.457",
    transform: "translate(-94.145 -88.292)",
    fill: "#ffd5ab"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M232.34,200.782a14.6,14.6,0,0,0-4.9,2.537,21.4,21.4,0,0,0-3.926,3.994,32.476,32.476,0,0,0-4.938,9.877,72.079,72.079,0,0,0-2.294,10.407c-.534,3.465-1,6.861-1.512,10.466a33.082,33.082,0,0,0,5.08-9.529c1.233-3.346,2.185-6.7,3.2-9.937a68.035,68.035,0,0,1,3.584-9.339,34.059,34.059,0,0,1,5.7-8.476",
    transform: "translate(-83.361 -77.931)",
    fill: "#ffd5ab"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M254.836,247.292a34.039,34.039,0,0,1-9.538,3.661,67.993,67.993,0,0,1-9.9,1.4c-3.382.265-6.864.441-10.4.894a33.091,33.091,0,0,0-10.424,2.818c3.627.313,7.043.615,10.539.871a72.131,72.131,0,0,0,10.657.094,32.474,32.474,0,0,0,10.731-2.6,21.377,21.377,0,0,0,4.773-2.932,14.6,14.6,0,0,0,3.569-4.207",
    transform: "translate(-83.282 -95.983)",
    fill: "#ffd5ab"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M211.663,211.723a14.586,14.586,0,0,0-5.117,2.062,21.333,21.333,0,0,0-4.286,3.605,32.465,32.465,0,0,0-5.851,9.365A72.153,72.153,0,0,0,193.14,236.9c-.86,3.4-1.649,6.735-2.5,10.276a33.077,33.077,0,0,0,5.959-9c1.544-3.214,2.809-6.463,4.126-9.589a67.986,67.986,0,0,1,4.451-8.958,34.057,34.057,0,0,1,6.481-7.9",
    transform: "translate(-73.996 -82.177)",
    fill: "#ffd5ab"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M231.366,261.516a34.055,34.055,0,0,1-9.842,2.742,67.95,67.95,0,0,1-9.993.458c-3.392-.056-6.875-.21-10.439-.094a33.071,33.071,0,0,0-10.644,1.818c3.581.655,6.953,1.278,10.409,1.863a72.076,72.076,0,0,0,10.6,1.1,32.474,32.474,0,0,0,10.929-1.574,21.358,21.358,0,0,0,5.028-2.467,14.59,14.59,0,0,0,3.951-3.85",
    transform: "translate(-73.92 -101.504)",
    fill: "#ffd5ab"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M190.953,220.389a14.59,14.59,0,0,0-5.289,1.571,21.365,21.365,0,0,0-4.607,3.185,32.47,32.47,0,0,0-6.706,8.772,72.123,72.123,0,0,0-4.21,9.79c-1.176,3.3-2.277,6.55-3.453,10a33.069,33.069,0,0,0,6.781-8.4c1.84-3.054,3.406-6.169,5.012-9.157a68.01,68.01,0,0,1,5.275-8.5,34.054,34.054,0,0,1,7.2-7.252",
    transform: "translate(-64.698 -85.541)",
    fill: "#ffd5ab"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M207.7,273.007a34.064,34.064,0,0,1-10.057,1.8,68.055,68.055,0,0,1-9.992-.486c-3.371-.376-6.825-.857-10.383-1.077a33.092,33.092,0,0,0-10.768.808c3.5.989,6.8,1.928,10.188,2.836a72.092,72.092,0,0,0,10.449,2.1,32.468,32.468,0,0,0,11.029-.537,21.362,21.362,0,0,0,5.238-1.982,14.589,14.589,0,0,0,4.3-3.461",
    transform: "translate(-64.625 -105.964)",
    fill: "#ffd5ab"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M296.253,147.843a13.942,13.942,0,0,0-2.461,5.862,18.272,18.272,0,0,0-.016,6.411c.1.529.211,1.057.348,1.578s.3,1.032.477,1.527a29.392,29.392,0,0,0,1.2,2.832c.882,1.819,1.787,3.482,2.7,5.43a9.764,9.764,0,0,0,.431-3.19,20.2,20.2,0,0,0-.321-3.132c-.169-1.013-.4-1.986-.594-2.928-.1-.471-.214-.929-.289-1.39-.1-.456-.182-.916-.261-1.376-.327-1.84-.56-3.7-.743-5.608s-.27-3.869-.476-6.016",
    transform: "translate(-113.918 -57.383)",
    fill: "#ffd5ab"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M318.361,158.153c-.646.9-1.194,1.765-1.788,2.585s-1.16,1.61-1.781,2.353-1.217,1.476-1.867,2.161-1.3,1.36-1.988,1.987c-.335.327-.689.63-1.046.932s-.717.6-1.084.89c-.738.592-1.489,1.116-2.319,1.692a26.092,26.092,0,0,0-2.538,1.908,7.662,7.662,0,0,0-2.022,2.618c2-.879,3.846-1.189,5.879-1.886a13.077,13.077,0,0,0,1.52-.61,14.041,14.041,0,0,0,1.484-.78,8.316,8.316,0,0,0,.7-.453c.229-.16.469-.308.687-.482.441-.344.876-.7,1.285-1.078s.789-.791,1.172-1.2c.349-.436.724-.849,1.033-1.315a15.255,15.255,0,0,0,1.634-2.895,12.452,12.452,0,0,0,1.035-6.431",
    transform: "translate(-117.189 -61.385)",
    fill: "#ffd5ab"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M167.322,63.3a16.91,16.91,0,0,1,23.545-21.588c2.941,1.582,5.343,3.984,8.026,5.969a5.949,5.949,0,0,1,2.232,2.3,5.2,5.2,0,0,1-.076,3.2,42.8,42.8,0,0,1-4.136,10.358c-.006-.129-.012-.258-.018-.387-.07-1.377-.182-2.6-.34-3.7-.814-5.4-2.056-8.483-3.978-13.6a22.6,22.6,0,0,1-18.846,16.942,2.866,2.866,0,0,0-1.271-1.008,2.945,2.945,0,0,0-2.572.24,3.43,3.43,0,0,0-1.459,2.331,4.763,4.763,0,0,0-.059,1,15.662,15.662,0,0,1-1.049-2.05",
    transform: "translate(-64.413 -15.416)",
    fill: "#21232b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M198.5,70.373c0,6.491-2.917,12.1-7.153,14.728-.193.123-.387.24-.586.346a9.293,9.293,0,0,1-1.066.51,10.023,10.023,0,0,1-3.814.762c-4.253,0-8.014-2.73-10.293-6.9a18.07,18.07,0,0,1-1.646-4.154,3.818,3.818,0,0,1-1.611-1.125,9.406,9.406,0,0,1-2.08-3.527,6.853,6.853,0,0,1-.352-1.775,4.763,4.763,0,0,1,.059-1,3.432,3.432,0,0,1,1.459-2.331,2.945,2.945,0,0,1,2.572-.24,2.863,2.863,0,0,1,1.271,1.008A22.6,22.6,0,0,0,194.107,49.74c1.922,5.114,3.163,8.2,3.978,13.6.158,1.1.27,2.326.34,3.7.006.129.012.258.017.387.041.914.059,1.9.059,2.947",
    transform: "translate(-65.943 -19.306)",
    fill: "#ff9a55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(122.843 47.691)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M200.768,77.944s5.859,7.4,5.261,8.46-4.827.814-4.827.814Z",
    transform: "translate(-200.768 -77.944)",
    fill: "#21232b"
  }))))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M177.717,100.141l.246-1.236c2.279,4.165,6.04,6.9,10.293,6.9a10.016,10.016,0,0,0,3.814-.762,9.333,9.333,0,0,0,1.066-.51l1.072,5.466.428,2.179-4.452,8.037-14.171-11.617.65-3.228Z",
    transform: "translate(-68.317 -38.389)",
    fill: "#ff9a55"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M170.057,90.768,169.811,92A8.469,8.469,0,0,1,158.083,79.79a5.347,5.347,0,0,1,5.237-1.652,15.735,15.735,0,0,0,1.049,2.05,6.843,6.843,0,0,0,.352,1.775,9.4,9.4,0,0,0,2.08,3.527,3.825,3.825,0,0,0,1.611,1.125,18.076,18.076,0,0,0,1.646,4.153",
    transform: "translate(-60.411 -30.253)",
    fill: "#21232b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M207.393,68.478A10.5,10.5,0,0,1,211.46,69.7c1.486.808.161,3.077-1.326,2.268a7.225,7.225,0,0,0-2.741-.866,1.35,1.35,0,0,1-1.314-1.313,1.323,1.323,0,0,1,1.314-1.314",
    transform: "translate(-79.987 -26.577)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(126.327 45.118)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M206.462,76.28a2.219,2.219,0,1,0,2.2-2.542,2.388,2.388,0,0,0-2.2,2.542",
    transform: "translate(-206.462 -73.738)",
    fill: "#21232b"
  }))))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M207.4,78.007a1.646,1.646,0,1,0,1.62-1.938,1.8,1.8,0,0,0-1.62,1.938",
    transform: "translate(-80.501 -29.525)",
    fill: "#21232b"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M191.276,68.139a10.505,10.505,0,0,0-4.067,1.224c-1.486.808-.161,3.077,1.326,2.268a7.225,7.225,0,0,1,2.741-.866,1.35,1.35,0,0,0,1.314-1.313,1.323,1.323,0,0,0-1.314-1.314",
    transform: "translate(-72.41 -26.445)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(115.554 44.91)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M193.246,75.94a2.219,2.219,0,1,1-2.2-2.542,2.388,2.388,0,0,1,2.2,2.542",
    transform: "translate(-188.855 -73.398)",
    fill: "#21232b"
  }))))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M193.036,77.668a1.646,1.646,0,1,1-1.62-1.938,1.8,1.8,0,0,1,1.62,1.938",
    transform: "translate(-73.667 -29.394)",
    fill: "#21232b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(109.262 60.516)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M180.032,103.645a17.992,17.992,0,0,0,15.459,7.826l-.289-1.477-1.073-5.466a9.542,9.542,0,0,1-1.066.51,10.027,10.027,0,0,1-3.814.761c-4.253,0-8.014-2.73-10.293-6.9l-.246,1.236-.138.685a14.543,14.543,0,0,0,1.46,2.821",
    transform: "translate(-178.572 -98.904)",
    fill: "#21232b"
  }))))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M195.358,126.967c2.719,3.743,5.759,27.47,5.759,27.47a29.306,29.306,0,0,1-6.193,1.084l-5.969,16.5,2.747,6.6v.006a4.637,4.637,0,0,0-1.716,1.7l-28.665-10.75-.346-8.324v-.006c.961-.176,1.951-.381,2.982-.627l1.6-12.976c-10.316,2.888-23.62.228-23.62.228.521-7.012,1.3-15.19,2.285-18.957,1.9-7.27,16.222-12.607,16.222-12.607a11.533,11.533,0,0,0,.064,2.46c.762,6.269,7.006,15.712,11.236,15.847s5.214-7.651,5.214-7.651,2.033,5.4,6.245,5.536c3.3.105,3.45-8.542.68-13.146.269.117,8.8,3.919,11.476,7.61",
    transform: "translate(-55.091 -45.145)",
    fill: "#2c3344"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M206.1,119.636c2.771,4.6,2.624,13.252-.68,13.146-4.212-.135-6.245-5.536-6.245-5.536l4.453-8.037-.428-2.179a5.633,5.633,0,0,1,2.894,2.6Z",
    transform: "translate(-77.306 -45.423)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M174.5,112.693l14.171,11.617s-.978,7.791-5.214,7.651-10.474-9.579-11.236-15.847a11.505,11.505,0,0,1-.065-2.461c.34-3.919,2.994-4.189,2.994-4.189Z",
    transform: "translate(-66.805 -42.487)",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M165.077,167.525l-1.6,12.976c-1.031.246-2.021.451-2.982.627-7.452,1.377-12.777.785-16.011.006A15.444,15.444,0,0,1,140.7,179.8s.27-5.519.756-12.045c0,0,13.3,2.66,23.62-.228",
    transform: "translate(-54.611 -65.023)",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M180.62,152.891,178.245,169.8l-.67,4.769c-.051.368.513.528.565.155q1.189-8.453,2.375-16.906l.67-4.768c.052-.369-.512-.529-.565-.156",
    transform: "translate(-68.922 -59.26)",
    fill: "#21232b"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M226.2,156.168a22.52,22.52,0,0,0-3.285-8.967c-.969-1.6-2.054-3.134-3.139-4.661-.217-.3-.724-.012-.506.3a43.894,43.894,0,0,1,4.976,8.2,19.266,19.266,0,0,1,.15,14.579c-.138.351.428.5.565.156a19.87,19.87,0,0,0,1.239-9.606",
    transform: "translate(-85.087 -55.275)",
    fill: "#21232b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M192.064,299.838H129.041c-.4-20.006.909-35.22,2.853-46.644,4.072-23.9,10.949-31.219,10.949-31.219a21.087,21.087,0,0,0,2.4.762s-.3,1.177-.721,3.21c-2.671,12.882-10.229,60.1,22.549,60.1A28.975,28.975,0,0,0,175.1,285h.006c7.645-2.2,12.062-7.645,14.458-14.359.252-.7.48-1.412.686-2.138l.041.738Z",
    transform: "translate(-50.058 -86.157)",
    fill: "#2c3344"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M196.689,228.2c.562,2.074,6.426,24.377,1.728,40.786-2.811,9.83-9.408,17.545-23.187,17.545-37.95,0-21.828-63.31-21.828-63.31,10.756,2.882,39.227,5.606,39.227,5.606s1.629-.193,4.06-.627",
    transform: "translate(-58.221 -86.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(81.836 135.818)",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M168.923,286.048A28.95,28.95,0,0,0,176.96,285a30.443,30.443,0,0,1-10.785,3.052,25.165,25.165,0,0,1-11.184-1.505,26,26,0,0,1-9.467-6.562,39.652,39.652,0,0,1-6.584-9.789,56.9,56.9,0,0,1-4.341-12.431q-.519-2.267-.849-4.569c4.071-23.9,10.949-31.219,10.949-31.219a20.923,20.923,0,0,0,2.4.761s-.3,1.178-.72,3.21c-2.671,12.882-10.229,60.1,22.548,60.1",
    transform: "translate(-133.749 -221.975)",
    fill: "#2c3344"
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M228.737,298.754c-.234.475-.475.937-.726,1.4.251-.7.48-1.412.685-2.138Z",
    transform: "translate(-88.499 -115.671)",
    fill: "#21232b"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M243.982,209.526H197.038a5.152,5.152,0,0,1-5.137-5.136v-3.037a5.152,5.152,0,0,1,5.137-5.137h46.944a5.151,5.151,0,0,1,5.136,5.137v3.037a5.151,5.151,0,0,1-5.136,5.136",
    transform: "translate(-74.484 -76.159)",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M259.04,187.774H212.1a5.152,5.152,0,0,1-5.137-5.136V179.6a5.152,5.152,0,0,1,5.137-5.137H259.04a5.151,5.151,0,0,1,5.136,5.137v3.037a5.151,5.151,0,0,1-5.136,5.136",
    transform: "translate(-80.328 -67.716)",
    fill: "#c5dddc"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M247.172,165.988H200.228a5.152,5.152,0,0,1-5.137-5.136v-3.037a5.152,5.152,0,0,1,5.137-5.137h46.944a5.151,5.151,0,0,1,5.136,5.137v3.037a5.151,5.151,0,0,1-5.136,5.136",
    transform: "translate(-75.722 -59.26)",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M275.265,159.857a5.194,5.194,0,0,0-3.9-2.043c-1.423-.087-3.284.417-4.035,1.746a1.778,1.778,0,0,0,.434,2.25,3.91,3.91,0,0,0,2.8.682c.75-.023,1.785-.075,2.136-.876a1.033,1.033,0,0,0-.72-1.5c-.373-.05-.369.537,0,.586.223.03.258.365.228.536a.788.788,0,0,1-.63.556,3.829,3.829,0,0,1-.948.108,7.187,7.187,0,0,1-1.308-.035,1.833,1.833,0,0,1-1.621-1.208c-.162-.724.47-1.319,1.031-1.654a4.7,4.7,0,0,1,3.564-.458,4.08,4.08,0,0,1,2.923,2.479c.444,1.416-.745,2.526-1.894,3.113a8.313,8.313,0,0,1-4.421.844c-2.419-.2-5.862-1.9-5.2-4.86a4.79,4.79,0,0,1,2.905-3.2,13.66,13.66,0,0,1,5.264-.7.293.293,0,0,0,0-.586,13.861,13.861,0,0,0-5.644.815,5.318,5.318,0,0,0-3.09,3.51,4.078,4.078,0,0,0,1.583,4.036,7.746,7.746,0,0,0,4.752,1.591,8.2,8.2,0,0,0,5.05-1.52,3.438,3.438,0,0,0,1.309-1.829,2.922,2.922,0,0,0-.563-2.392",
    transform: "translate(-102.098 -60.411)",
    fill: "#c5dddc"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M273.242,203.262a5.194,5.194,0,0,0-3.9-2.043c-1.423-.087-3.284.417-4.035,1.746a1.778,1.778,0,0,0,.434,2.25,3.91,3.91,0,0,0,2.8.682c.75-.023,1.785-.075,2.136-.876a1.033,1.033,0,0,0-.72-1.5c-.373-.05-.369.537,0,.586.223.03.258.365.228.536a.788.788,0,0,1-.63.556,3.829,3.829,0,0,1-.948.108,7.185,7.185,0,0,1-1.308-.035,1.832,1.832,0,0,1-1.621-1.208c-.162-.724.47-1.319,1.031-1.654a4.7,4.7,0,0,1,3.564-.458,4.08,4.08,0,0,1,2.923,2.479c.444,1.416-.745,2.527-1.894,3.114a8.314,8.314,0,0,1-4.421.844c-2.419-.2-5.862-1.9-5.2-4.86a4.79,4.79,0,0,1,2.905-3.2,13.66,13.66,0,0,1,5.264-.7.293.293,0,0,0,0-.586,13.861,13.861,0,0,0-5.644.815,5.318,5.318,0,0,0-3.09,3.51,4.078,4.078,0,0,0,1.583,4.036A7.746,7.746,0,0,0,267.445,209a8.2,8.2,0,0,0,5.05-1.52,3.438,3.438,0,0,0,1.309-1.829,2.922,2.922,0,0,0-.563-2.392",
    transform: "translate(-101.312 -77.259)",
    fill: "#c5dddc"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M222.269,181.419a5.194,5.194,0,0,0-3.9-2.043c-1.423-.087-3.284.417-4.035,1.746a1.778,1.778,0,0,0,.434,2.25,3.909,3.909,0,0,0,2.8.682c.75-.023,1.785-.075,2.136-.876a1.033,1.033,0,0,0-.72-1.5c-.373-.05-.369.537,0,.586.223.03.258.365.228.536a.788.788,0,0,1-.63.556,3.828,3.828,0,0,1-.948.108,7.188,7.188,0,0,1-1.308-.035,1.833,1.833,0,0,1-1.621-1.208c-.162-.724.47-1.319,1.031-1.654a4.7,4.7,0,0,1,3.564-.458,4.08,4.08,0,0,1,2.923,2.479c.444,1.416-.745,2.527-1.894,3.114a8.314,8.314,0,0,1-4.421.844c-2.419-.2-5.862-1.9-5.2-4.86a4.79,4.79,0,0,1,2.905-3.2,13.66,13.66,0,0,1,5.264-.7.293.293,0,0,0,0-.586,13.862,13.862,0,0,0-5.644.815,5.318,5.318,0,0,0-3.09,3.51,4.078,4.078,0,0,0,1.583,4.036,7.746,7.746,0,0,0,4.752,1.591,8.2,8.2,0,0,0,5.05-1.52,3.438,3.438,0,0,0,1.309-1.829,2.922,2.922,0,0,0-.563-2.392",
    transform: "translate(-81.528 -68.78)",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M195.445,215.211c-2.431.434-4.06.627-4.06.627s-28.471-2.724-39.227-5.606a21.093,21.093,0,0,1-2.4-.762,3.175,3.175,0,0,1-1.593-1.013c-1.787-3.422-1.319-18.694-1.319-18.694,3.234.78,8.559,1.371,16.011-.006v.006l.345,8.325,28.665,10.75a4.635,4.635,0,0,1,1.716-1.7v-.005c2.677-1.582,6.7-1.066,6.7-1.066s6.133-7.03,6.625-5.208-2.718,6.075-2.718,6.075h11.617c-3.439,4.681-14.359,7.211-20.363,8.278",
    transform: "translate(-56.976 -73.652)",
    fill: "#ff9a55"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M198.469,99.4a5.116,5.116,0,0,0-5.751-2.717c-.3.083-.461-.371-.162-.455a5.611,5.611,0,0,1,6.367,3.01c.141.276-.315.435-.454.162",
    transform: "translate(-74.677 -37.279)",
    fill: "#21232b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M154.942,154.839q-.023,3.746-.045,7.491a.293.293,0,0,0,.586,0q.022-3.746.045-7.491a.293.293,0,0,0-.586,0",
    transform: "translate(-60.121 -59.989)",
    fill: "#21232b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesad);
export default __webpack_public_path__ + "static/media/peoplesad.a85927983df9423dec14f7c30e93bcb1.svg";
export { ForwardRef as ReactComponent };